import { Component, Input, OnInit } from '@angular/core';
import { SubscriptionLevel } from 'src/app/auth/models/user';
import { ApplicationSettingsService } from 'src/app/services/application-settings.service';
import { DataVersionService } from 'src/app/services/data-version.service';

import { RouteService } from 'src/app/services/route.service';
import { UserService } from 'src/app/services/user.service';
import { NumericKeyValueState } from 'src/app/_models/state/optionUIState';
import { Route } from 'src/app/_models/view/Route';
import { ModalboxComponent } from '../../modalbox/modalbox.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-data-version-list',
  templateUrl: './data-version-list.component.html',
})
export class DataVersionListComponent implements OnInit {
  @Input() route: Route;
  @Input() disabled: boolean;
  dataVersions: NumericKeyValueState[] = [];
  dataVersionList$ = this.dataversionService.dataVersions;
  defaultDataVersion: string | number;
  dataVersionDisplay: string | number;
  applicationData: any;

  constructor(
    private modalService: BsModalService,
    private routeService: RouteService,
    private applicationSettingsService: ApplicationSettingsService,
    private userService: UserService,
    private dataversionService: DataVersionService
  ) {}

  ngOnInit(): void {
    this.dataVersionList$.subscribe((data) => {
      this.dataVersions = data;
      if (this.dataVersions?.length > 0) {
        const currentVersion = this.dataVersions?.find(function (item) {
          return item.value === 'current';
        });

        const nonCurrentVersion = this.dataVersions?.find(function (item) {
          return item.value !== 'current';
        });

        if (
          this.userService.getUser().subscriptionLevel !==
          SubscriptionLevel.PREMIUM
        ) {
          // for standard user we are providing only the updated dataversion
          this.defaultDataVersion = nonCurrentVersion?.value;
          this.route.historicalDataVersion = nonCurrentVersion?.value as string;
        } else {
          if (
            this.route.historicalDataVersion ===
              this.userService.getUser().dataset ||
            !this.route.historicalDataVersion
          ) {
            this.defaultDataVersion = currentVersion?.value;
          } else {
            this.defaultDataVersion = this.route.historicalDataVersion;
          }
        }
        this.dataVersionDisplay = this.dataVersions?.find(
          (version) => version.value === this.defaultDataVersion
        )?.display;
      }
    });

    this.routeService.logMinDataVersion(this.defaultDataVersion as string);
    this.applicationSettingsService.store$.subscribe((data) => {
      this.applicationData = data;
    });
  }
  changeDataVersion(selectedDataVersion: string) {
    if (
      selectedDataVersion.toUpperCase() < 'PCM28' &&
      selectedDataVersion.toUpperCase() !== 'CURRENT' &&
      selectedDataVersion.toUpperCase() !== 'PCM_NA' &&
      selectedDataVersion.toUpperCase() !== 'PCM_EU'
    ) {
      const initialState = {
        title: 'Older PC*MILER Versions',
        list: [
          'You may encounter errors and limitations when using PC*MILER v27 and earlier, which are inherit to those versions. These issues are generally minor but for best compatability and stability consider using the most recent version of PC*MILER.',
        ],
        actionButtonText: 'Okay, Got it!',
        btnClass: 'btn btn-primary',
        okOnly: true,
        closeOnly: true,
      };

      const dialogRef = this.modalService.show(ModalboxComponent, {
        initialState,
        ignoreBackdropClick: true,
        keyboard: false,
        animated: true,
        class: 'modal-dialog-centered',
      });
    }
    this.routeService.setDataVersion(
      selectedDataVersion,
      this.route,
      this.applicationData
    );
  }
}
